import { useState } from 'react';
import { formatHeat } from '@/utils/format';

type HotComment = {
  user: string;
  text: string;
  likes: number;
  badge?: string;
};

function CommentItem({ comment }: { comment: HotComment }) {
  const [liked, setLiked] = useState(false);
  const likes = comment.likes + (liked ? 1 : 0);

  return (
    <li className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex items-center gap-3">
        <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 font-heading text-base text-primary-700">
          {comment.user.slice(0, 1)}
        </span>
        <div className="min-w-0">
          <p className="truncate text-sm text-foreground-950">{comment.user}</p>
          <p className="text-xs text-foreground-500">网友热评</p>
        </div>
        {comment.badge && (
          <span className="ml-auto shrink-0 rounded-full bg-accent-100 px-2.5 py-1 text-xs text-accent-900">
            {comment.badge}
          </span>
        )}
      </div>
      <p className="mt-3.5 text-sm leading-relaxed text-foreground-700">{comment.text}</p>
      <button
        type="button"
        onClick={() => setLiked((prev) => !prev)}
        aria-pressed={liked}
        aria-label={liked ? '取消点赞' : '点赞这条热评'}
        className={`mt-4 flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-xs transition-colors ${
          liked ? 'bg-primary-100 text-primary-700' : 'text-foreground-500 hover:bg-background-100'
        }`}
      >
        <i className={liked ? 'ri-thumb-up-fill' : 'ri-thumb-up-line'} aria-hidden="true" />
        {formatHeat(likes)}
      </button>
    </li>
  );
}

export default function SceneComments({ comments }: { comments: HotComment[] }) {
  return (
    <section id="comments" className="mt-12 scroll-mt-24">
      <div className="flex items-end justify-between gap-4 border-b border-background-200 pb-4">
        <h2 className="m-0 text-xl text-foreground-950 md:text-3xl">这段现场的热评</h2>
        <span className="shrink-0 text-xs text-foreground-500 md:text-sm">
          共 {comments.length} 条精选评论
        </span>
      </div>
      <ul className="mt-5 space-y-4">
        {comments.map((comment) => (
          <CommentItem key={comment.user} comment={comment} />
        ))}
      </ul>
      <p className="mt-5 rounded-md bg-background-100 px-4 py-3 text-xs leading-relaxed text-foreground-500">
        评论内容来自网友公开讨论的整理，昵称与头像均为化名处理，仅用于还原现场氛围。
      </p>
    </section>
  );
}